import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthContextService } from '@core/services/auth-context.service';

export const uploadFilesLoginGuard: CanMatchFn = async () => {
  const ctx = inject(AuthContextService);
  const router = inject(Router);

  const logged = await ctx.syncSession();
  if (!logged) return true;

  const mode = ctx.getMode();
  return router.createUrlTree([mode === 'upload-files' ? '/upload' : '/home']);
};
